// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as ProtectedNewRouteImport } from './routes/_protected/new'
import { Route as ProtectedExampleProtectedRouteRouteImport } from './routes/_protected/example-protected-route'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected/dashboard'
import { Route as ProtectedBillingRouteImport } from './routes/_protected/billing'

const CallbackRoute = CallbackRouteImport.update({
            id: '/callback',path: '/callback',getParentRoute: () => rootRouteImport
          })
const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const ProtectedRoute = ProtectedRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRoute
          })
const ProtectedNewRoute = ProtectedNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => ProtectedRoute
          })
const ProtectedExampleProtectedRouteRoute = ProtectedExampleProtectedRouteRouteImport.update({
            id: '/example-protected-route',path: '/example-protected-route',getParentRoute: () => ProtectedRoute
          })
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => ProtectedRoute
          })
const ProtectedBillingRoute = ProtectedBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => ProtectedRoute
          })





const ProtectedRouteChildren = {
  ProtectedBillingRoute: ProtectedBillingRoute,ProtectedDashboardRoute: ProtectedDashboardRoute,ProtectedExampleProtectedRouteRoute: ProtectedExampleProtectedRouteRoute,ProtectedNewRoute: ProtectedNewRoute
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(ProtectedRouteChildren)




const PublicRouteChildren = {
  PublicIndexRoute: PublicIndexRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren = {
  ProtectedRoute: ProtectedRouteWithChildren,PublicRoute: PublicRouteWithChildren,CallbackRoute: CallbackRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)